module.exports = __webpack_public_path__ + "img/receipt_engine-2023-01.8ee507dd.jpg";